import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import "swiper/css/thumbs";
import "swiper/css/effect-fade";

import { NewsSlider } from "./modules/NewsSlider";
import Animations from "./modules/Animations";
import ScrollTrigger from "gsap/dist/ScrollTrigger";
import gsap from "gsap";
import Accordion from "./modules/Accordion";
import AlphabetSlider from "./modules/AlphabetSlider";
import BODSlider from "./modules/BODSlider";
import BODCards from "./modules/BODCard";
import TabsSlider from "./modules/TabsSlider";
import Header from "./modules/Header";
gsap.registerPlugin(ScrollTrigger);

class App {
	constructor() {
		this.init();
	}

	init() {
		console.log(":::: WJI ::::");
		this.initModules();
	}

	initModules() {
		// Init Modules here
		new Header();
		new Animations();

		const newsSlider = document.querySelector("[js-news-slider]");
		newsSlider && new NewsSlider(newsSlider);

		const accordions = document.querySelectorAll("[js-accordion]");
		accordions && accordions.forEach((acc) => new Accordion(acc));

		const alphabetSlider = document.querySelector("[js-alphabet-slider]");
		alphabetSlider && new AlphabetSlider(alphabetSlider);

		const bodSlider = document.querySelector("[js-bod-slider]");
		bodSlider && new BODSlider(bodSlider);

		const bodCards = document.querySelector("[js-bod-card]");
		bodCards && new BODCards(bodCards);

		const tabs = document.querySelector("[js-tabs-container]");
		tabs && new TabsSlider(tabs);
	}
}

if (document.readyState === "loading") {
	// Loading hasn't finished yet
	window.addEventListener("DOMContentLoaded", () => new App());
} else {
	// `DOMContentLoaded` has already fired
	new App();
}
